












































































import Vue from "vue";
import store, { BankPreAccEditorStore } from "../services/BankPreAccEditorStore";

interface Data {
  store: BankPreAccEditorStore;
}

interface Methods {
  formatMoney(value: number): string;
}

export default Vue.extend<Data, Methods, {}, {}>({
  data() {
    return {
      store,
    };
  },
  methods: {
    formatMoney(value: number): string {
      const formatted = new Intl.NumberFormat("hu-HU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(value) || 0);
      return `${formatted} ${this.store.head.currency}`.trim();
    },
  },
});
